import React from "react";

import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { Characteristic } from "store/types";

import { Form } from "./Form";

interface Props {
  onSuccess: (characteristic: Characteristic) => void;
  onCancel: () => void;
  /** "deal" (default) is omitted from the payload; "client" scopes the definition to the Client CRM. */
  entityType?: "deal" | "client";
}

export const Create: React.FC<Props> = ({ onSuccess, onCancel, entityType = "deal" }) => {
  const { createCharacteristicAction } = useDealActions();

  const { loading, action } = useActionHook(createCharacteristicAction, {
    onSuccess
  });

  return (
    <Form
      onSubmit={(values) => action(entityType === "client" ? { ...values, entity_type: "client" } : values)}
      isLoading={loading}
      onCancel={onCancel}
      entityType={entityType}
    />
  );
};
